module.exports = __webpack_public_path__ + "static/media/loader-icon.cc05a2c6.svg";